function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, CallToAction, Heading } from '../../atoms';
import { LightArrowRight } from '../../visuals';
import ReactConfigContext from '../../ReactConfigContext';
export default function SimpleInfoEntry(param) {
    var label = param.label, title = param.title, description = param.description, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('grid grid-cols-1 grid-flow-row auto-cols-max gap-5', className)
    }, /*#__PURE__*/ React.createElement(LinkComponent, action, !!label && /*#__PURE__*/ React.createElement(Body, {
        className: "font-heading font-bold text-body-small mb-3"
    }, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title)), !!description && /*#__PURE__*/ React.createElement(LinkComponent, action, /*#__PURE__*/ React.createElement(Body, {
        variant: "md"
    }, description)), !!action.label && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        variant: "button/link"
    }))));
}

//# sourceMappingURL=SimpleInfoEntry.js.map